<div *ngIf="this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaOnderhoudsverplichtingen &&
            Object.keys(this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaOnderhoudsverplichtingen || {}).length > 0">
    <form [formGroup]="specOverigePGAFormGroup">
        <div formGroupName="specificatieOverigePGA">
            <div formGroupName="opbouw">
                <div>
                    <div *ngIf="specOverigePGAFormGroup.get(['specificatieOverigePGA', 'opbouw', 'totaalAftrekbareAlimentatie'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p><b>Aftrekbare alimentatie</b></p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        formControlName="totaalAftrekbareAlimentatie"
                                        id="totaalAftrekbareAlimentatie"
                                        class="me-1 custom-input-150 custom-readonly"
                                        [disabledControl]="true"
                                        [decimals]="0"
                                        prefix="€"
                                        align="right"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaWeekendUitgavenGehandicapteKinderen &&
            Object.keys(this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaWeekendUitgavenGehandicapteKinderen || {}).length > 0">
    <form [formGroup]="specOverigePGAFormGroup">
        <div formGroupName="specificatieOverigePGA">
            <div formGroupName="opbouw">
                <div>
                    <div *ngIf="specOverigePGAFormGroup.get(['specificatieOverigePGA', 'opbouw', 'aftrekPerVerzorgingsdagWeekenduitgaven'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Aftrek per verzorgingsdag</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        formControlName="aftrekPerVerzorgingsdagWeekenduitgaven"
                                        id="aftrekPerVerzorgingsdagWeekenduitgaven"
                                        class="me-1 custom-input-150 custom-readonly"
                                        [disabledControl]="true"
                                        [decimals]="0"
                                        prefix="€"
                                        align="right"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div *ngIf="specOverigePGAFormGroup.get(['specificatieOverigePGA', 'opbouw', 'aftrekReiskostenWeekenduitgaven'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Aftrek reiskosten</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        formControlName="aftrekReiskostenWeekenduitgaven"
                                        id="aftrekReiskostenWeekenduitgaven"
                                        class="me-1 custom-input-150 custom-readonly"
                                        [disabledControl]="true"
                                        [decimals]="0"
                                        prefix="€"
                                        align="right"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div *ngIf="specOverigePGAFormGroup.get(['specificatieOverigePGA', 'opbouw', 'vergoedingWeekenduitgaven'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p>Af: Ontvangen vergoeding </p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        formControlName="vergoedingWeekenduitgaven"
                                        id="vergoedingWeekenduitgaven"
                                        class="me-1 custom-input-150 custom-readonly"
                                        [disabledControl]="true"
                                        [decimals]="0"
                                        prefix="€ -"
                                        align="right"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                    <div>
                        <div class="row">
                            <div class="col col-1">
                                <p><b>Aftrekbare weekenduitgaven</b></p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        formControlName="totaleWeekenduitgaven"
                                        id="totaleWeekenduitgaven"
                                        class="me-1 custom-input-150 custom-readonly"
                                        [disabledControl]="true"
                                        [decimals]="0"
                                        prefix="€"
                                        align="right"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.restantPgaVoorgaandeJaren &&
            Object.keys(this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.restantPgaVoorgaandeJaren || {}).length > 0">
    <form [formGroup]="specOverigePGAFormGroup">
        <div formGroupName="specificatieOverigePGA">
            <div formGroupName="opbouw">
                <div>
                    <div *ngIf="specOverigePGAFormGroup.get(['specificatieOverigePGA', 'opbouw', 'totaalRestantPga'])?.value > 0">
                        <div class="row">
                            <div class="col col-1">
                                <p><b>Restant persoonsgebonden aftrek voorgaande jaren</b></p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        formControlName="totaalRestantPga"
                                        id="totaalRestantPga"
                                        class="custom-input-150 custom-readonly"
                                        [disabledControl]="true"
                                        [decimals]="0"
                                        prefix="€"
                                        align="right"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
